import { isDefined } from '@aloft/toolkit-shared';

// eslint-disable-next-line aloft/prefer-sound-ui-box
import { CheckBoxNodeAttributes } from './utils.ts';

export function createCheckBoxFieldNode(doc: XMLDocument, attributes: CheckBoxNodeAttributes) {
  const node = doc.createElement('CheckBoxField');
  node.setAttribute('Id', attributes.Id);
  node.setAttribute('Data', `${attributes.Data}`);
  if (isDefined(attributes.additional)) {
    for (const [key, val] of Object.entries(attributes.additional)) {
      if (isDefined(val)) node.setAttribute(key, val);
    }
  }
  return node;
}
